import ApplicationModel, { attr } from '../ApplicationModel';
import { type DiscoveryResearchItemAttributes } from './generated/DiscoveryResearchItemAttributes';
import { model } from '../modelBuilder';

interface DiscoveryResearchItem extends DiscoveryResearchItemAttributes {}

@model
class DiscoveryResearchItem extends ApplicationModel {
  // Start auto-generated
  static typename: 'DiscoveryResearchItem' = 'DiscoveryResearchItem';
  get typename(): 'DiscoveryResearchItem' {
    return 'DiscoveryResearchItem';
  }

  static internalTypename: 'Discovery::ResearchItem' =
    'Discovery::ResearchItem';
  get internalTypename(): 'Discovery::ResearchItem' {
    return 'Discovery::ResearchItem';
  }

  static inputType = 'DiscoveryResearchItemAttributes!';

  static filterType = 'ResearchItemFilters!';
  static filters = {
    id: '[ID!]',
    itemType: 'DiscoveryResearchItemItemType',
    researchableId: 'ID',
    researchableType: 'String',
  };

  static fields = {
    createdAt: attr({ readable: true }),
    id: attr({ readable: true }),
    itemType: attr({ writable: true, readable: true }),
    name: attr({ writable: true, readable: true }),
    position: attr({ writable: true, readable: true }),
    updatedAt: attr({ readable: true }),
    researchable: attr.belongsTo({
      writeShape: ['id', 'typename'],
      readable: true,
      typename: ['Unimplemented'],
    }),
  };
  // End auto-generated

  positionInList(list: DiscoveryResearchItem[]): number {
    return list.findIndex(item => item.id === this.id);
  }
}

export default DiscoveryResearchItem;
